<ng-container [formGroup]="customForm">
    <div class="ui-widget w-100">
        <input [id]="dropdownId" class="drop-menu multiselect font-14 w-100" [placeholder]="placeholder" formControlName="customControl"
        (click)="showOptions()">
    </div>
</ng-container>